import { Switch, Route, Redirect } from 'react-router-dom';
import { NavBar, Toast } from '@components';
import { useLocation } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Container } from '@mui/material';
import jimboTheme from './jimboTheme';
import './app-style.css';
import { useAppDispatch, useAppSelector } from '@hooks/redux-custom';
import { useEffect } from 'react';
import { setUserInfo } from '@store/slices/authentication';
import { RouteModules as routes, CommonModules } from './routes';
import { Role } from '@models';

const theme = createTheme(jimboTheme);

function App(): JSX.Element {
  const { user } = useAppSelector((state) => state.activeUser.value);
  const token = localStorage.getItem('token');
  const location = useLocation();
  const authValue = useAppSelector((state) => state.Auth.value);

  const moduleName = user?.roles?.find((role: Role) => role.role)?.moduleName ?? '';

  const baseRedirect = moduleName ? routes.find((route) => route.module === moduleName && route.isLandingPage)?.path ?? '/login' : '/login';

  const dispatch = useAppDispatch();

  console.log(process.env.REACT_APP_API_URL);

  useEffect(() => {
    dispatch(setUserInfo(token));
  }, [dispatch, token]);

  const routeAuthenticated = (routeName: string) => {
    const activeModules = user?.roles.filter((role: any) => role.role);

    return activeModules?.find((module: any) => module.moduleName === routeName);
  };

  if (location.pathname === '/') {
    return <Redirect to={baseRedirect} />;
  }

  const AuthenticatedPages = () => {
    const modules = routes.filter((route) => routeAuthenticated(route.module));

    return (
      <>
        <NavBar />
        <Container maxWidth="lg" data-testid="main-container">
          <Switch>
            {modules.map((route) => (
              <Route key={`${route.name}-${new Date().getTime()}`} path={route.path}>
                {route.component}
              </Route>
            ))}
            {CommonModules.map((route) => (
              <Route key={`${route.name}-${new Date().getTime()}`} path={route.path}>
                {route.component}
              </Route>
            ))}
          </Switch>
        </Container>
        <Toast />
      </>
    );
  };

  const nonAuthPages = () => {
    return (
      <>
        <Switch>
          {CommonModules.map((route) => (
            <Route key={`${route.name}-${new Date().getTime()}`} path={route.path}>
              {route.component}
            </Route>
          ))}
        </Switch>
        <Toast />
      </>
    );
  };

  return <ThemeProvider theme={theme}>{authValue?.refreshToken ? AuthenticatedPages() : nonAuthPages()}</ThemeProvider>;
}

export default App;
